<template>
  <div class="contain">
      <div class="topBack">
          <el-button type="text" @click="$router.go(-1)">
              <i class="el-icon-arrow-left"></i>{{ $t('Index.ShoppingCar.Back') }}
          </el-button>
      </div>
      <div class="content f">
        <div class="content_left">
          <template v-if="addressList.length">
            <div class="left_shippingAddress f-b content_item p-r">
              <div class="f">
                <div>
                  <div style="font-weight: bold;margin-bottom: 10px" class="f--c text_tip">
                      <span style="margin-right:4px;font-size:20px">{{ $t('Index.ShoppingCar.ShippingAddress') }}</span>
                      <dispatch-explain></dispatch-explain>
                  </div>
                  <div style="color:#8B93A3;padding-left: 20px" v-if="addressList.length">
                    {{addressList[selectAddressIndex].fullName}} {{addressList[selectAddressIndex].phoneNumber}}
                    <p>{{addressList[selectAddressIndex].streetAddressLine1}}</p>
                    <p v-if="addressList[selectAddressIndex].streetAddressLine2">{{addressList[selectAddressIndex].streetAddressLine2}}</p>
                    {{addressList[selectAddressIndex].city}} {{addressList[selectAddressIndex].province}} {{addressList[selectAddressIndex].countryName}} {{addressList[selectAddressIndex].zipCode}} {{addressList[selectAddressIndex].vatCode}}
                  </div>
                </div>
                <div class="select-another-address pointer fd-c f-e" style="margin-left: 14px" @click="editAddress(addressList[selectAddressIndex])">{{ $t('Index.ShoppingCar.Edit') }}</div>
              </div>
              <div>
                <el-popover placement="bottom">
                  <div class="select-another-address pointer" slot="reference">{{ $t('Index.ShoppingCar.Choose') }}</div>
                  <vue-scroll :style="{ height: `${addressList.length > 3 ? '400': addressList.length*200}px`}">
                    <div class="add-new-address f-c pointer" @click="$refs.addressdialog.show(undefined, true)">
                      <i class="iconfont icon-a-add-line1"></i>&nbsp;
                      <span>{{ $t('confirmOrder.addNewAddress') }}</span>
                    </div>
                    <div v-for="(item, index) in addressList" :key="item.id" class="address-item p-r pointer" :class="[index === selectAddressIndex ? 'address-item-activated' : '']" @click="selectAddressIndex = index">
                      {{item.fullName}} {{item.phoneNumber}}
                      <p>{{item.streetAddressLine1}}</p>
                      <p v-if="item.streetAddressLine2">{{item.streetAddressLine2}}</p>
                      {{item.city}} {{item.province}} {{item.countryName}} {{item.zipCode}} {{item.vatCode}}
                      <span class="pointer" @click.stop="editAddress(item)">{{$t('confirmOrder.editTheAddress')}}</span>
                      <div class="activated-icon">
                        <i class="iconfont icon-check-line"></i>
                      </div>
                    </div>
                  </vue-scroll>
                </el-popover>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="left_shippingAddress f-b content_item">
                <div style="font-weight: bold" class="f--c text_tip">
                    <i class="el-icon-location-information" style="margin-right:4px"></i>{{ $t('Index.ShoppingCar.ShippingAddress') }}
                </div>
                <el-button type="primary" @click="$refs.addressdialog.show(undefined, true)">{{ $t('Index.ShoppingCar.AddNewAddress') }}</el-button>
            </div>
          </template>
          <div class="content_item warehouse">
              <div class="f-b">
                <h2 class="title" style="font-size:20px">{{ $t('Index.ShoppingCar.ShoppingBag') }}</h2>
                <!-- <div class="pointer deleteIcon f--c" v-if="currentCountryWarehouse.items.length > 5" @click="batchDelete">
                  <i class="el-icon-delete" style="font-size: 20px;margin-right:8px"></i>
                  Delete All
                </div> -->
              </div>
              <template v-if="filterSet.length > 1">
                <p class="multiple_tip">{{ $t('Index.ShoppingCar.Tips4') }} <span style="color: #E53353">{{filterSet.length}} {{ $t('Index.ShoppingCar.Warehouses') }}</span></p>
                <p class="multiple_tip">{{ $t('Index.ShoppingCar.Tips5') }}</p>
              </template>
              <template v-if="cartList.length">
                <el-tabs v-model="countryNameActive" @tab-click="warehouseHandleClick" class="warehouseTabs">
                  <el-tab-pane :label="`${item.countryNameForTab} (${itemsNum(item)})`" v-for="item in filterSet" :key="item.warehouseCode" :name="item.countryNameForTab">
                    <div v-if="isNoMatchingChannel" class="noMatchingTip">
                      <p>{{ $t('Index.ShoppingCar.ItemsFrom') }} *{{ countryNameActive }}* {{ $t('Index.ShoppingCar.Tips6') }}</p>
                    </div>
                    <div class="select_all">
                      <el-checkbox v-model="item.checkAll" @change="v=> selectAll(v, item)">{{ $t('Index.ShoppingCar.SelectAll') }}</el-checkbox>
                      <span style="margin-left: 38px;color: #747A87;font-size: 14px" class="pointer" @click="batchDelete">{{ $t('Index.ShoppingCar.Delete') }}</span>
                    </div>

                    <!-- 商品列表 -->
                    <div style="max-height: 800px;overflow-y: scroll">
                      <div class="product_group f" v-for="spuProduct in item.kkProductIdGroup" :key="spuProduct.kkProductId">
                        <div style="margin-right: 14px"><el-checkbox v-model="spuProduct.checked" @change="value=>spuCheck(value, item)" :disabled="spuProduct.isDisabled"></el-checkbox></div>
                        <div class="product_img">
                          <el-popover
                            placement="right"
                            width="400"
                            trigger="hover">
                            <el-image :src="spuProduct.imgUrl" style="width:100%;" fit="fill"></el-image>
                            <div slot="reference" class="img">
                              <el-image :src="spuProduct.imgUrl" fit="contain"></el-image>
                              <div v-if="spuProduct.productType === 3" class="tag-pod">POD</div>
                            </div>
                          </el-popover>
                        </div>
                        <div style="flex: 1" class="productInfo">
                          <div class="f-b">
                            <p class="pointer productTitle" @click="jumpDetailSeo(spuProduct.kkProductId)">{{spuProduct.skuName}}</p>
                            <el-popconfirm :title="$t('Index.ShoppingCar.Tips16')" @confirm="spuDelete(spuProduct)">
                              <i class="el-icon-delete pointer" style="font-size: 18px"  slot="reference"></i>
                            </el-popconfirm>
                          </div>
                          <div class="productPrice">
                            <span v-if="spuProduct.afterDiscountAmount">US ${{spuProduct.afterDiscountAmount}}</span>
                            <span>US ${{spuProduct.price}}</span>
                          </div>
                          <carFlashTime :endTime="spuProduct.endTime" v-if="spuProduct.discountType && spuProduct.discountType === 1"></carFlashTime>
                          <div v-for="color in spuProduct.colorAll" :key="color" class="colorGroup">
                              <p class="colorText">{{color}}</p>
                              <el-table :data="[spuProduct[color]]" class="colorBookTable" style="width: 700px">
                                <el-table-column v-for="size in spuProduct[color].sizeAll" :key="size" :prop="size" :label="size" width="60" align="center">
                                  <template slot-scope="scope">
                                    <template v-if="scope.row[`${size}status`] !== 1">
                                      <el-tooltip effect="dark" content="Out of Stock" placement="top">
                                        <p class="pointer" style="color: #8B93A3">{{ scope.row[size] }}</p>
                                      </el-tooltip>
                                    </template>
                                    <template v-else>
                                      <el-input v-model="scope.row[size]" :disabled="scope.row.isHaveMinOrderQuantity || !scope.row[`${size}stock`]" @input="v => colorNumInput(v, scope.row, size)" @blur="v=> spuSizeBlur(v, size, scope.row, spuProduct)"></el-input>
                                    </template>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="" label="" >
                                </el-table-column>
                                <el-table-column prop="pack" label="PACK" width="120" align="center" fixed="right">
                                  <template slot-scope="scope">
                                    <el-input-number
                                    v-model="scope.row.packNum"
                                    style="width: 100%"
                                    class="packInput"
                                    :disabled="!scope.row.isHaveMinOrderQuantity || Object.keys(scope.row).filter(t=>t.includes('status')).some(t=>scope.row[t] !== 1)"
                                    :min="0"
                                    :max="maxPackNum(scope.row)"
                                    @change="value => productBatch(value, scope.row, spuProduct)"
                                    @input="value => scope.row.packNum = parseInt(`${value}`.replace(/[^\d]/g, ''))"></el-input-number>
                                  </template>
                                </el-table-column>
                                <el-table-column label="QTY" width="60" align="center" fixed="right">
                                  <template slot-scope="scope">
                                    {{ colorPackQTY(scope.row) }}
                                  </template>
                                </el-table-column>
                                <el-table-column label="AMT" width="100" align="center" fixed="right">
                                  <template slot-scope="scope">
                                    {{ `$ ${colorPackPrice(scope.row)}` }}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                        </div>
                      </div>
                    </div>

                    <div class="f-e" style="height:76px;line-height:76px">
                      <span style="font-size:14px;color:#747A87;margin-right:4px;">{{ $t('Index.ShoppingCar.Weight') }}:</span>
                      <span style="font-size:16px;font-weight:bold;margin-right:24px">{{ tableWeightTotal | priceHandle }}g</span>
                      <span style="font-size:14px;color:#747A87;margin-right:4px">{{ $t('Index.ShoppingCar.Subtotal') }}:</span>
                      <span style="font-size:16px;font-weight:bold;">US ${{tableSubtotalPack | priceHandle}}</span>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </template>
              <template v-else>
                <div style="text-align:center;padding-bottom:60px">
                  <div style="margin-bottom:10px">
                    <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.584 49.584H125.417L113.167 125.417H26.834L14.584 49.584Z" stroke="#CDD4DD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M102.083 49.584C102.083 30.2541 87.7184 14.584 69.9993 14.584C52.2803 14.584 37.916 30.2541 37.916 49.584" stroke="#CDD4DD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M49.5833 81.6667C52.805 81.6667 55.4167 79.055 55.4167 75.8333C55.4167 72.6117 52.805 70 49.5833 70C46.3617 70 43.75 72.6117 43.75 75.8333C43.75 79.055 46.3617 81.6667 49.5833 81.6667Z" fill="#CDD4DD"/>
                      <path d="M52.5 96.25C52.5 96.25 58.3333 105 70 105C81.6667 105 87.5 96.25 87.5 96.25" stroke="#CDD4DD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M90.4173 81.6667C93.639 81.6667 96.2507 79.055 96.2507 75.8333C96.2507 72.6117 93.639 70 90.4173 70C87.1957 70 84.584 72.6117 84.584 75.8333C84.584 79.055 87.1957 81.6667 90.4173 81.6667Z" fill="#CDD4DD"/>
                    </svg>
                  </div>
                  <h2 style="margin-bottom:14px">{{ $t('Index.ShoppingCar.YourBagIsEmpty') }}</h2>
                  <div>
                    <el-button type="primary" style="width:200px;height:46px;font-size: 16px" @click="jumpHref('/mall')">{{ $t('Index.ShoppingCar.StartShopping') }}</el-button>
                  </div>
                </div>
              </template>
          </div>
          <div class="content_item deliveryMethod" v-loading="loading">
            <div class="f-b" style="margin-bottom: 10px">
              <h2 style="font-size:20px">{{ $t('Index.ShoppingCar.DeliveryMethod') }}</h2>
              <h3 style="font-size:16px">{{ $t('Index.ShoppingCar.Warehouses') }}: {{countryNameActive}}</h3>
            </div>
            <template v-if="channelError && !channelList.length">
              <div class="f">
                <div class="image" style="margin-right:14px">
                  <img src="../../assets/img/Group2151.png" style="height:40px;width:40px">
                </div>
                <div style="font-size:16px;line-height:24px">
                  <p style="color:#E3444E">{{ $t('Index.ShoppingCar.LogisticsError') }}.</p>
                  <p>{{ $t('Index.ShoppingCar.Tips7') }}</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="channel_group">
                <div class="channel_item" v-for="item in channelList" :key="item.channelCode" :class="{channel_item_active: channelActive === item.channelCode}">
                  <el-radio v-model="channelActive" :label="item.channelCode" @change="couponApply">
                    {{`${item.agingGrade} (${item.deliveryTime}, $${item.estimatedFreight})`}}
                  </el-radio>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="content_right" id="content_right">
          <div class="coupon content_item">
            <div class="f-b f--c" >
              <span style="font-size: 18px">{{ $t('Index.ShoppingCar.AddKakaCloCode') }}</span>
              <el-switch v-model="couponValue">
              </el-switch>
            </div>
            <template v-if="couponValue">
              <div class="coupon-code f--c">
                <el-input v-model.trim="couponCode" class="coupon-code-input" clearable @clear="clearCouponCode" @blur="clearCouponCode" :placeholder="$t('Index.ShoppingCar.EnterPromoCode')"></el-input>
                <el-button type="primary" :loading="couponInfo.loading" class="coupon-code-btn" @click="couponApply">{{ $t('Index.ShoppingCar.Apply') }}</el-button>
              </div>
              <div v-if="couponInfo.message && !couponInfo.error" class="f-c-c">
                <i class="iconfont icon-checkbox-circle-fill success" style="font-size:22px;margin-right:6px"></i>
                <div>{{ couponInfo.message }}</div>
              </div>
              <div v-if="couponInfo.message && couponInfo.error" class="f-c-c error">
                <i class="iconfont icon-a-close-line1"></i>
                <div>{{ couponInfo.message }}</div>
              </div>
              <div v-if="couponInfo.message && !couponInfo.error" class="coupon-bar f-c-c">
                <img src="@/assets/img/icon/coupon.svg" style="margin-right:6px" alt="">
                <div v-if="+couponInfo.discountRule === 3">{{ $t('Index.ShoppingCar.Tips8') }}.</div>
                <div v-else>{{ `${couponInfo.discountCondition===1?('Order '+couponInfo.satisfyNum+', '):couponInfo.discountCondition===2?('Spend $'+couponInfo.satisfyAmount+', '):''}` }}Get <span class="error">{{`${couponInfo.discountRule===1?(couponInfo.discountPercent+'% off'):('$'+couponInfo.discountFixed+' off')}`}}</span></div>
              </div>
            </template>
          </div>

          <!-- 优惠券模块 -->
          <div class="car-coupon">
            <el-collapse v-model="collapse" accordion>
              <el-collapse-item name="coupon">
                <template slot="title">
                  <p class="car-coupon-tips">
                    <span class="car-title">Coupons</span>
                    <span v-if="getAvailableCouponQuantity" class="car-available">
                      <i class="iconfont icon-youhuiquan" />
                      <span>{{ getAvailableCouponQuantity }} {{ getAvailableCouponQuantity > 1 ? 'Coupons' : 'Coupon' }} Available</span>
                    </span>
                    <span v-else class="car-tips">No coupons available</span>
                  </p>
                </template>

                <!-- 优惠券列表 -->
                <ul v-if="coupons && coupons.length" class="car-coupons-ul">
                  <CouponItem v-for="coupon in coupons" :key="coupon.id" :coupon="coupon" class="car-coupon-item" @click="onClickCoupon" />
                </ul>

                <!-- 空状态 -->
                <template v-else>
                  <div class="not-data">
                    <img src="~@/assets/img/coupon.png" alt="img.svg" />
                    <span class="tips-text">{{ $t('Order.Refund.Mobile.Index.NoRecord') }}</span>
                  </div>
                </template>
              </el-collapse-item>
            </el-collapse>

            <!-- 已选中的优惠券状态 -->
            <div v-if="coupon.id" class="choose-to-use">
              <i class="iconfont icon-youhuiquan" />
              <span class="get-info">
                <strong class="get">Get </strong>
                <span v-if="getOfferTypePrice" class="discount">{{coupon.receiveUsageRules.offerTypeInfo.fixedType === 1 ? `$${coupon.receiveUsageRules.offerTypeInfo.reduction}` : `$${coupon.receiveUsageRules.offerTypeInfo.reduction}% off`}}</span>
                <span v-else>-</span>
              </span>
            </div>
          </div>

          <!-- Order Amount -->
          <!-- <div class="content_item orderAmount" v-loading="loading">
            <h2 style="margin-bottom: 10px" class="title">{{ $t('Index.ShoppingCar.OrderAmount') }}</h2>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.Subtotal') }}</p>
              <p>US ${{tableSubtotalPack | priceHandle }}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.ShippingFee') }}</p>
              <p>US ${{currentChannel.estimatedFreight | priceHandle }}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.Discount') }}</p>
              <p :class="{haveCut: allDiscountPack}">-US ${{allDiscountPack | priceHandle}}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.PromoCode') }}</p>
              <p :class="{haveCut: couponInfo.discountAmount}">-US ${{ couponInfo.discountAmount | priceHandle }}</p>
            </div>
            <el-divider></el-divider>
            <div class="f-b subtotal_all f--c">
              <p>{{ $t('Index.ShoppingCar.Total') }}：</p>
              <p>US ${{totalAllPack | priceHandle}}</p>
            </div>
            <div class="checkoutBtn">
              <el-button type="primary" @click="processCheck" style="height: 50px;font-size:16px" :disabled="!filterSet.length || !currentCountryWarehouse.kkProductIdGroup.filter(e=>e.checked).length">Confirm Order</el-button>
            </div>
            <p class="numTip">
              {{ $t('Index.ShoppingCar.YouHaveSelected') }} <span>{{selectProductNum}}</span> {{ $t('Index.ShoppingCar.OutOf') }} <span>{{allProductNum}}</span>  {{ $t('Index.ShoppingCar.ToCheckout') }}.
            </p>
            <el-divider class="zeroMB"></el-divider>
            <div class="paymentOptions">
              <p>{{ $t('Index.ShoppingCar.Tips9') }}</p>
              <div class="icon_group f-c-c">
                <img src="../../assets/img/icon/paypal.png">
                <img src="../../assets/img/icon/creditcard1.png">
                <img src="../../assets/img/icon/others.png">
              </div>
            </div>
          </div> -->

          <div class="content_item orderAmount" v-loading="loading">
            <h2 style="margin-bottom: 10px" class="title">{{ $t('Index.ShoppingCar.OrderAmount') }}</h2>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.Subtotal') }}</p>
              <p>US ${{tableSubtotalPack | priceHandle }}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.ShippingFee') }}</p>
              <p>US ${{currentChannel.estimatedFreight | priceHandle }}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.Discount') }}</p>
              <p :class="{haveCut: orderBillingPreviewInfo.activityDiscountTotalAmount}">-US ${{orderBillingPreviewInfo.activityDiscountTotalAmount | priceHandle}}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">{{ $t('Index.ShoppingCar.PromoCode') }}</p>
              <p :class="{haveCut: orderBillingPreviewInfo.couponCodeTotalAmount}">-US ${{ orderBillingPreviewInfo.couponCodeTotalAmount | priceHandle }}</p>
            </div>
            <div class="f-b subtotal_item">
              <p style="color: #747A87">Coupon</p>
              <p :class="{haveCut: orderBillingPreviewInfo.couponTicketTotalAmount}">-US ${{ orderBillingPreviewInfo.couponTicketTotalAmount | priceHandle }}</p>
            </div>
            <el-divider></el-divider>
            <div class="f-b subtotal_all f--c">
              <p>{{ $t('Index.ShoppingCar.Total') }}：</p>
              <p>US ${{ orderBillingPreviewInfo.transactionTotalAmount | priceHandle }}</p>
            </div>
            <div class="checkoutBtn">
              <el-button :loading="checkoutLoading" type="primary" @click="checkBindEmail" style="height: 50px;font-size:16px" :disabled="!filterSet.length || !currentCountryWarehouse.kkProductIdGroup.filter(e=>e.checked).length">Confirm Order</el-button>
            </div>
            <p class="numTip">
              {{ $t('Index.ShoppingCar.YouHaveSelected') }} <span>{{selectProductNum}}</span> {{ $t('Index.ShoppingCar.OutOf') }} <span>{{allProductNum}}</span>  {{ $t('Index.ShoppingCar.ToCheckout') }}.
            </p>
            <el-divider class="zeroMB"></el-divider>
            <div class="paymentOptions">
              <p>{{ $t('Index.ShoppingCar.Tips9') }}</p>
              <div class="icon_group f-c-c">
                <img src="../../assets/img/icon/paypal.png">
                <img src="../../assets/img/icon/creditcard1.png">
                <img src="../../assets/img/icon/others.png">
              </div>
            </div>
          </div>

          <!-- 常见问题 -->
          <div class="common-problem content_item">
            <h3>{{$t('confirmOrder.commonProblem')}}</h3>
            <el-collapse accordion>
              <el-collapse-item :title="$t('Index.ShoppingCar.HowToReturn')" name="1">
                <div>{{ $t('Index.ShoppingCar.Tips10') }}</div>
              </el-collapse-item>
              <el-collapse-item :title="$t('Index.ShoppingCar.ReturnAndReturnIssues')" name="2">
                <div>{{ $t('Index.ShoppingCar.Tips11') }}</div>
              </el-collapse-item>
              <el-collapse-item :title="$t('Index.ShoppingCar.WrongReceiptInformation')" name="4">
                <div>{{ $t('Index.ShoppingCar.Tips12') }}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <!-- <div style="width: 392px;height: 1px;display: none" :class="{isShow: rightIsFixed}"></div> -->
      </div>
      <AddressDialog ref="addressdialog" :addForm="addressForm" @submitForm="getAddressList"></AddressDialog>
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        width="400px">
        <div class="f dialogCheckTip">
          <div style="margin-right:13px" class="dialogCheckTip_icon"><i class="el-icon-warning" style="color: #E53353;font-size:28px"></i></div>
          <div style="font-size:12px" class="dialogCheckTip_font">
            <p style="color: #E53353">{{ $t('Index.ShoppingCar.Tips13') }}</p>
            <p> {{ $t('Index.ShoppingCar.Tips14') }} {{otherCountryHaveChoice.countryNameForTab}} ?</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogCancel">{{ $t('Index.ShoppingCar.Cancel') }}</el-button>
          <el-button type="primary" @click="dialogCheck">{{ $t('Index.ShoppingCar.Sure') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="processVisible" width="450px" custom-class="processCheckingDialog" :close-on-click-modal="false" @close="processDialogClose">
        <div class="f">
          <div class="iconBox">
            <i class="el-icon-warning"></i>
          </div>
          <div class="noteBox">
            <p class="note1">{{ $t('Index.ShoppingCar.Tips15') }}</p>
            <div>
              <el-checkbox v-model="isAskMeAgainChecked">{{ $t('Index.ShoppingCar.DontAskMeAgain') }}</el-checkbox>
            </div>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="processDialogClose">{{ $t('Index.ShoppingCar.LetMeCheckAgain') }}</el-button>
          <el-button type="primary" @click="processDialogSubmit">{{ $t('Index.ShoppingCar.GotIt') }}</el-button>
        </div>
      </el-dialog>
      <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
  </div>
</template>

<script>
import API from '@/api'
import cloneDeep from 'lodash/cloneDeep'
import AddressDialog from '@/views/commodity/components/AddressDialog'
import _ from 'lodash'
import dayjs from 'dayjs'
import carFlashTime from './components/carFlashTime.vue'
import DispatchExplain from '../commodity/components/dispatchExplain.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'

// 优惠券模块
import CouponItem from '@/components/CouponItem.vue'

const numToFix = (num) => {
  if (!num) return num
  return parseFloat(num.toFixed(2))
}
export default {
  components: {
    AddressDialog,
    carFlashTime,
    DispatchExplain,
    AccountSetting,
    CouponItem
  },
  filters: {
    priceHandle(value) {
      if (value) return value.toFixed(2)
      return '0.00'
    }
  },
  data() {
    return {
      collapse: undefined,

      // 优惠券模块 - 当前选中的优惠券
      coupon: {},

      // 优惠券模块 - 优惠券列表
      coupons: [
        // {
        //   id: 1, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 1, // 是否可用：0.否 1.是
        //   status: 0, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: undefined, // 优惠券图标
        //   // logoUrl: 'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 2, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 168 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 1 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 1, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 98 // 减少量
        //     }
        //   }
        // },
        // {
        //   id: 2, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 1, // 是否可用：0.否 1.是
        //   status: 0, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 1, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 100 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 2 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 2, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 15 // 减少量
        //     }
        //   }
        // },
        // {
        //   id: 3, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 0, // 是否可用：0.否 1.是
        //   status: 1, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: 'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 2, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 100 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 1 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 1, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 200 // 减少量
        //     }
        //   }
        // }
      ],

      couponValue: false,
      countryNameActive: 'china',
      cartList: [],
      filterSet: [], // 分类后的数据
      timer: null,
      addressForm: {
        fullName: undefined,
        phoneNumber: undefined,
        streetAddressLine1: undefined,
        streetAddressLine2: undefined,
        city: undefined,
        province: undefined,
        countryCode: undefined,
        zipCode: undefined,
        vatCode: undefined
      },
      selectAddressIndex: 0,
      tableSelectionChangeTime: 0,
      channelList: [],
      channelActive: undefined,
      loading: false,
      couponCode: undefined,
      couponInfo: {},
      couponLoading: false,
      dialogVisible: false,
      dialogHandleInfo: {
        selections: [],
        warehouse: null
      },
      channelError: false,
      allLoading: null,
      rightIsFixed: false,
      fixedRight: 0,
      endTimeObj: {}, // key为 discountId
      endTimeInterval: null,
      currentTime: dayjs().valueOf(),
      processVisible: false,
      isAskMeAgainChecked: false,

      // 获取购物车订单预览信息请求参数
      parameter: {
        // 订单商品信息
        products: [
          // {
          //   kkProductId: undefined, // 商品ID
          //   skuCode: undefined, // SKU编码
          //   skuOriginalPriceAmount: undefined, // SKU原价金额
          //   skuQuantity: undefined // SKU数量
          // }
        ],
        couponCode: undefined, // 优惠码
        selectCouponTicketId: undefined, // 客户优惠券ID
        shippingSubtotal: undefined, // 总运费
        ifApplication: true // 当只有一张优惠券时是否自动应用：是否自动应用：true.应用 false.不应用
      },

      orderBillingPreviewInfo: {}, // 订单计费预览信息对象

      checkoutLoading: false
    }
  },
  created() {
    this.getCartList()
  },
  mounted() {
    this.$store.dispatch('common/getBalance')
    this.$store.dispatch('common/getAddressList')
    this.$store.dispatch('common/getShoppingCarIsNeedTips')
  },
  watch: {
    selectAddressIndex() {
      this.getLogisticsChannel().then(() => {
        this.couponApply()
      })
    }
  },
  computed: {
    /**
     * 优惠券模块 - 获取已选中的优惠券的优惠类型
     */
    getOfferTypePrice() {
      return this.coupon.receiveUsageRules && this.coupon.receiveUsageRules.offerTypeInfo && this.coupon.receiveUsageRules.offerTypeInfo.fixedType ? this.coupon.receiveUsageRules.offerTypeInfo.fixedType : undefined
    },

    /**
     * 优惠券模块 - 获取可用优惠券的数量
     */
    getAvailableCouponQuantity() {
      let quantity = 0
      if (this.coupons.length) {
        this.coupons.forEach((coupon) => {
          if (coupon.status === 0 && coupon.ifUsed === 1) {
            quantity += 1
          }
        })
      }
      return quantity
    },

    addressList() {
      return this.$store.state.common.addressList
    },
    currentAddress() {
      return this.$store.state.common.addressList.find(e => e.isDefault)
    },
    selectAddress() {
      if (this.$store.state.common.addressList.length) return this.addressList[this.selectAddressIndex]
      return {}
    },
    tableWeightTotal() {
      const currenntWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { kkProductIdGroup: [] }
      let total = 0
      currenntWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let num = 0
            if (spuProduct[color].isHaveMinOrderQuantity) {
              num = (spuProduct[color][size] * spuProduct[color].packNum)
            } else {
              num = spuProduct[color][size]
            }
            total += +(num * spuProduct[color][`${size}packageWeight`]).toFixed(2)
          })
        })
      })
      return total
    },
    tableSubtotalPack() {
      const currenntWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { kkProductIdGroup: [] }
      let total = 0
      currenntWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let num = 0
            if (spuProduct[color].isHaveMinOrderQuantity) {
              num = (spuProduct[color][size] * spuProduct[color].packNum)
            } else {
              num = spuProduct[color][size]
            }
            if (spuProduct[color][`${size}afterDiscountAmount`]) {
              total += +(num * spuProduct[color][`${size}afterDiscountAmount`]).toFixed(2)
            } else {
              total += +(num * spuProduct[color][`${size}price`]).toFixed(2)
            }
          })
        })
      })
      return total
    },
    allDiscountPack() {
      const currenntWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { kkProductIdGroup: [] }
      let total = 0
      currenntWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let num = 0
            if (spuProduct[color].isHaveMinOrderQuantity) {
              num = (spuProduct[color][size] * spuProduct[color].packNum)
            } else {
              num = spuProduct[color][size]
            }
            if (spuProduct[color][`${size}promotionAmount`]) total += parseFloat((num * spuProduct[color][`${size}promotionAmount`]).toFixed(2))
          })
        })
      })
      return parseFloat(total.toFixed(2))
    },
    totalAllPack() {
      let final = this.tableSubtotalPack + this.currentChannel.estimatedFreight
      if (this.couponInfo.discountAmount) final -= this.couponInfo.discountAmount
      if (this.orderBillingPreviewInfo.couponTicketTotalAmount) final -= this.orderBillingPreviewInfo.couponTicketTotalAmount
      if (final < 0) return 0
      return final
    },
    isNoMatchingChannel() {
      if (!this.addressList.length) return false
      let ReceiptCountryCode = this.addressList[this.selectAddressIndex].countryCode
      let currentCountryWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { countryCode: '' }
      let warehouseCountryCode = currentCountryWarehouse.countryCode
      if (warehouseCountryCode === 'US' && ReceiptCountryCode !== 'US') return true
      if (warehouseCountryCode === 'DE' && ReceiptCountryCode !== 'DE') return true
      if (warehouseCountryCode === 'GB' && ReceiptCountryCode !== 'GB') return true
      return false
    },
    currentChannel() {
      if (this.channelActive && this.channelList.length) return this.channelList.find(e => e.channelCode === this.channelActive)
      return { estimatedFreight: 0 }
    },
    currentCountryWarehouse() {
      return this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { items: [], selections: [] }
    },
    otherCountryHaveChoice() {
      let target = this.filterSet.find(e => e.selections.length && e.countryNameForTab !== this.countryNameActive)
      return target || { countryNameForTab: '' }
    },
    promotionSubtotal() {
      let final = 0
      if (this.couponInfo.discountAmount) final += this.couponInfo.discountAmount
      if (this.orderBillingPreviewInfo.couponTicketTotalAmount) final += this.orderBillingPreviewInfo.couponTicketTotalAmount
      if (this.allDiscountPack) final += this.allDiscountPack
      return numToFix(final)
    },
    allProductNum() {
      const currenntWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { kkProductIdGroup: [] }
      let total = 0
      currenntWarehouse.kkProductIdGroup.forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let num = 0
            if (spuProduct[color].isHaveMinOrderQuantity) {
              num = +(spuProduct[color][size] * spuProduct[color].packNum)
            } else {
              num = +spuProduct[color][size]
            }
            total += num
          })
        })
      })
      return total
    },
    selectProductNum() {
      const currenntWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { kkProductIdGroup: [] }
      let total = 0
      currenntWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let num = 0
            if (spuProduct[color].isHaveMinOrderQuantity) {
              num = (spuProduct[color][size] * spuProduct[color].packNum)
            } else {
              num = spuProduct[color][size]
            }
            total += +num
          })
        })
      })
      return total
    },
    addressCurrent() {
      if (this.orderInfo.address) return this.orderInfo.address
      return {
        city: '',
        country: '',
        email: '',
        phone: '',
        province: '',
        recipient: '',
        street1: '',
        street2: '',
        zip: ''
      }
    }
  },
  destroyed() {
    clearInterval(this.endTimeInterval)
  },
  methods: {
    /**
     * API 获取购物车订单预览信息
     */
    async getOrderBillingPreviewInfo() {
      try {
        let { code, message, data } = await API.getOrderBillingPreviewInfo(this.parameter)
        if (code === 10000) {
          this.orderBillingPreviewInfo = data
          this.coupons = data.orderBillingFilterResults.couponTicketInfos || [] // 获取优惠券
          if (this.coupons && this.coupons.length && data?.selectCouponTicketId) {
            this.coupons.forEach((item) => {
              if (item.id === data?.selectCouponTicketId) {
                if (item.ifUsed === 1) {
                  item.selected = true
                  this.coupon = cloneDeep(item)
                  this.parameter.selectCouponTicketId = data?.selectCouponTicketId
                } else {
                  item.selected = false
                  this.coupon = {}
                }
              } else {
                item.selected = false
              }
            })
          } else {
            this.coupon = {}
          }
        } else {
          this.$message.error(message)
          this.orderBillingPreviewInfo = {}
        }
      } catch (error) {
        throw new Error(error.message)
      } finally {
        // 关闭展开框
        this.collapse = undefined
      }
    },

    /**
     * 优惠券模块 - 点击某个优惠券时触发的事件
     *
     * @param {Number} id 当前点击的优惠券ID
     */
    onClickCoupon(id) {
      this.coupons.forEach((item) => {
        if (item.id === id) {
          item.selected = !item.selected
          if (item.selected) {
            this.coupon = cloneDeep(item)
          } else {
            this.coupon = {}
          }
        } else {
          item.selected = false
        }
      })
      this.parameter.ifApplication = false // 取消默认应用
      this.parameter.selectCouponTicketId = this.coupon.id // 优惠券ID
      // 调用接口获取购物车订单预览信息
      this.getOrderBillingPreviewInfo()
    },

    warehouseHandleClick(val) {
      this.coupon = {}
      this.orderBillingPreviewInfo = {}
      this.parameter.selectCouponTicketId = undefined
      this.getLogisticsChannel()
      if (this.couponCode) this.couponApply()
    },
    getCartList() {
      if (!this.$store.state.common.userId) {
        this.buildCart()
        return
      }
      API.getCartList().then(result => {
        result.data.forEach(item => {
        // 将option字符串保存一下，创建订单的时候要用
          item.option1String = item.option1
          item.option2String = item.option2
          try {
            item.option1 = JSON.parse(item.option1)
            item.option2 = JSON.parse(item.option2)
          } catch (error) {
            item.option1 = item.option2 = {}
          }
          item.checked = false
          item.disabled = false
        })
        this.cartList = result.data
        // 根据仓库分类
        const filterSet = []
        /*
          根据discountId 分类 限时秒杀倒计时分开
        */
        this.cartList.forEach(e => {
          let target = filterSet.find(ee => {
            if (['CN_S', 'CN_N'].includes(e.countryCode) && ['CN_S', 'CN_N'].includes(ee.countryCode)) return true
            return ee.countryCode === e.countryCode
          })
          if (!target) {
            const item = {
              checkAll: false,
              warehouseName: e.warehouseName,
              items: [e],
              show: true,
              countryCode: e.countryCode,
              warehouseCode: e.warehouseCode,
              shipTo: undefined,
              selections: [], // 选中项
              warehouseType: e.warehouseType,
              warehouseId: e.warehouseId,
              disabled: false,
              kkProductIdGroup: [], // 根据kkProductId分组 颜色为子数组
              kkProductIdGroupSelections: []// 根据kkProductId分组的选中状态
            }
            item.countryNameForTab = ['CN_S', 'CN_N'].includes(e.countryCode) ? 'China' : e.countryCn
            filterSet.push(item)
          } else {
            target.items.push(e)
          }
          if (e.discountId && !this.endTimeObj[e.discountId]) this.endTimeObj[e.discountId] = e.endTime
        })
        const timer = setInterval(() => {
          const current = new Date().getTime()
          const time = this.deadline - current
          if (time <= 0) {
            this.day = 0
            this.time = '0000'
            return clearInterval(timer)
          }
          const day = parseInt(dayjs.tz(time, 'GMT').format('DD')) - 1
          const timeStr = dayjs.tz(time, 'GMT').format('HHmmss')
          let hours = String(parseInt(timeStr.slice(0, 2)) + day * 24)
          if (hours.length === 1) hours = '0' + hours
          this.hours = hours
          this.time = timeStr.slice(2)
        }, 1000)
        this.$once('hook:beforeDestroy', () => {
          clearInterval(timer)
        })
        this.filterSet = filterSet
        this.computedNum()
        if (this.filterSet.length) this.countryNameActive = this.filterSet[0].countryNameForTab
        // 生成根据kkProductId分组的数组
        /*
          kkProductIdGroup: [
            {
              展示参数 标题、价格、预览图...,
              [color]: {
                [size]: 有起订量为起订量，无起订量为num,
                pack: 有起订量为包裹数，无则为0,
                sizeAll: []// 表格渲染column用
                ...剩余创建订单属性
              },
              colorAll: ['red', 'blur', 'yellow']// 表格渲染column用
            }
          ]
        */
        this.filterSet.forEach(item => {
          item.items.forEach(secondItem => {
            const { status, price, afterDiscountAmount, num, minOrderQuantity } = secondItem
            let color = secondItem.option1.value
            let size = secondItem.option2.value
            let target = item.kkProductIdGroup.find(e => e.kkProductId === secondItem.kkProductId)
            if (!target) {
              const obj = {
                kkProductId: secondItem.kkProductId,
                imgUrl: secondItem.imgUrl,
                skuName: secondItem.skuName,
                afterDiscountAmount: secondItem.afterDiscountAmount,
                price: secondItem.price,
                colorAll: [],
                checked: false,
                warehouseCode: secondItem.warehouseCode,
                endTime: secondItem.endTime,
                discountType: secondItem.discountType,
                warehouseType: secondItem.warehouseType,
                warehouseId: secondItem.warehouseId,
                promotionAmount: secondItem.promotionAmount,
                discountId: secondItem.discountId,
                productType: secondItem.productType
              }
              item.kkProductIdGroup.push(obj)
              target = obj
            }
            !target.colorAll.includes(color) && target.colorAll.push(color)
            if (!target[color]) {
              target[color] = { isHaveMinOrderQuantity: !!minOrderQuantity, afterDiscountAmount, price, sizeAll: [], minOrderQuantity }
              // 是否有起订量，有则计算出包裹数量，无则包裹为0
              if (minOrderQuantity) {
                target[color].packNum = secondItem.stock ? (num / minOrderQuantity) : 0
              } else {
                target[color].packNum = 0
              }
            }
            this.$set(target[color], [size], minOrderQuantity || (num > secondItem.stock ? secondItem.stock : num))
            this.$set(target[color], [`${size}Status`], status)
            this.$set(target[color], [`${size}SkuCode`], secondItem.skuCode)
            this.$set(target[color], [`${size}Id`], secondItem.id)
            this.$set(target[color], [`${size}option1String`], secondItem.option1String)
            this.$set(target[color], [`${size}option2String`], secondItem.option2String)
            this.$set(target[color], [`${size}price`], secondItem.price)
            this.$set(target[color], [`${size}afterDiscountAmount`], secondItem.afterDiscountAmount)
            this.$set(target[color], [`${size}promotionAmount`], secondItem.promotionAmount)
            this.$set(target[color], [`${size}packageWeight`], secondItem.packageWeight)
            this.$set(target[color], [`${size}status`], secondItem.status)
            this.$set(target[color], [`${size}imgUrl`], secondItem.imgUrl)
            this.$set(target[color], [`${size}stock`], secondItem.stock)
            target[color].sizeAll.push(size)
          })
        })
        /*
          尺码排序
          [5XS 4XS 3XS XXS XS S M L XL XXL 3XL 4XL 5XL ...其余特殊尺码]
        */
        this.filterSet.forEach(warehouse => {
          warehouse.kkProductIdGroup.forEach(spu => {
            spu.colorAll.forEach(color => {
              let newSizeAll = []
              ;['5XS', '4XS', '3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'].forEach(size => {
                let index = spu[color].sizeAll.findIndex(e => e === size)
                if (index !== -1) {
                  newSizeAll.push(size)
                  spu[color].sizeAll.splice(index, 1)
                }
              })
              newSizeAll = [...newSizeAll, ...spu[color].sizeAll]
              spu[color].sizeAll = newSizeAll
            })
          })
        })
        // 给spu设置状态，复选框使用
        this.filterSet.forEach(warehouse => {
          warehouse.kkProductIdGroup.forEach(spu => {
            let isDisabled = false
            isDisabled = spu.colorAll.every(color => {
              return spu[color].sizeAll.every(size => {
                if (spu[color].isHaveMinOrderQuantity) {
                  let sizeList = spu[color].sizeAll.map(x => ({
                    status: spu[color][`${x}status`],
                    stock: spu[color][`${x}stock`]
                  }))
                  return sizeList.some(y => (y.status !== 1 || y.stock === 0))
                }
                return spu[color][`${size}status`] !== 1 || spu[color][`${size}stock`] === 0
              })
            })
            this.$set(spu, 'isDisabled', isDisabled)
          })
        })
        this.getLogisticsChannel()
        // 倒计时定时器
        const that = this
        this.endTimeInterval = setInterval(() => {
          that.currentTime = new Date().getTime()
        }, 1000)
      })
    },
    // 未登陆使用缓存里的购物车
    buildCart() {
      this.cartList = this.$store.state.common.cartList
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.updatePrice()
      }, 1000)
    },
    updatePrice() {
      const now = new Date().getTime()
      this.cartList.forEach(item => {
        if (item.endTime && now > item.endTime) {
          this.$set(item, 'endTime', undefined)
          this.$set(item, 'afterDiscountAmount', undefined)
          this.$set(item, 'discountPercent', undefined)
          this.$set(item, 'promotionAmount', undefined)
          this.$set(item, 'discountId', undefined)
        }
      })
    },
    handleSelectionChange(selections, warehouse) {
    // 已选择其他国家的产品则提示是否继续，确定则取消其他国家只保留当前仓库勾选
      let isHaveChoice = this.filterSet.some(e => e.countryNameForTab !== warehouse.countryNameForTab && e.selections.length)
      if (isHaveChoice) {
        this.dialogVisible = true
        this.dialogHandleInfo = {
          selections,
          warehouse
        }
      } else {
        warehouse.selections = selections
        this.allLoading = this.$loading.service()
        this.getLogisticsChannel().then(() => {
          if (this.couponCode) this.couponApply()
        }).finally(() => {
          this.allLoading.close()
        })
      }
    },
    qtyInputChange(value, row) {
      if (value && value.length && ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(+value.substr(0, 1))) row.num = undefined
      if (row.num !== undefined) this.updateCartNumber(row.skuCode, row.warehouseCode, row.num)
    },
    blurQtyInput(value, row) {
      if (value.target.value && !Number.isNaN(parseInt(value.target.value))) {
        if (parseInt(value.target.value) < 0) row.num = 1
        if (parseInt(value.target.value) > row.stock) {
          row.num = row.stock
        }
        this.updateCartNumber(row.skuCode, row.warehouseCode, row.num)
      } else {
        this.updateCartNumber(row.skuCode, row.warehouseCode, 0)
      }
    },
    updateCartNumber: _.debounce(function(skuCode, warehouseCode, num) {
      API.updateCartNumber({ skuCode, warehouseCode, num })
      this.getLogisticsChannel().then(() => {
        this.couponApply()
        this.computedNum()
      })
    }, 1000, { leading: false, trailing: true }),
    tableDeleteClick(row, item) {
      API.deleteCart([row.id]).then(result => {
        let index = item.items.findIndex(e => e.id === row.id)
        item.items.splice(index, 1)
        this.$message.success(result.message)
        let i = item.selections.findIndex(e => e.id === row.id)
        if (i !== -1) item.selections.splice(i, 1)
        let ii = this.cartList.findIndex(e => e.id === row.id)
        if (ii !== -1) this.cartList.splice(ii, 1)
        this.computedNum()
      })
    },
    getAddressList(address) {
      this.$refs.addressdialog._data.dialogVisible = false
      this.$refs.addressdialog._data.loading = false
      this.$store.dispatch('common/getAddressList').then(() => {
        this.getLogisticsChannel().then(() => {
          this.couponApply()
        })
      })
    },
    editAddress(address) {
      this.$set(this, 'addressForm', address)
      this.$refs.addressdialog.show(undefined, false)
    },
    getLogisticsChannel(isNoSetDefault) {
      return new Promise((resolve, reject) => {
        if (!this.addressList.length) {
          return resolve()
        }
        let currentWarehouse = this.filterSet.find(e => this.countryNameActive === e.countryNameForTab)
        const selections = currentWarehouse.kkProductIdGroup.filter(e => e.checked)
        if (!currentWarehouse) return
        if (currentWarehouse && !selections.length) {
          this.channelError = false
          this.channelList = []
          return resolve()
        }
        // let termini = this.addressList[this.selectAddressIndex].countryCode
        let address = this.addressList[this.selectAddressIndex]
        const params = {
          warehouses: [{
            termini: address.countryCode,
            warehouseCode: currentWarehouse.warehouseCode,
            channelGrouping: currentWarehouse.warehouseType,
            warehouseId: currentWarehouse.warehouseId,
            province: address.province || undefined,
            city: address.city || undefined,
            zipCode: address.zipCode || undefined,
            street1: address.streetAddressLine1 || undefined,
            street2: address.streetAddressLine2 || undefined,
            platformCode: 'KA'
          }],
          currency: 'USD'
        }
        const products = []
        selections.forEach(spuProduct => {
          spuProduct.colorAll.forEach(color => {
            spuProduct[color].sizeAll.forEach(size => {
              if (spuProduct[color][`${size}status`] !== 1) return
              let num = 0
              if (spuProduct[color].isHaveMinOrderQuantity) {
                num = (spuProduct[color][size] * spuProduct[color].packNum)
              } else {
                num = spuProduct[color][size]
              }
              num && products.push({ skuCode: spuProduct[color][`${size}SkuCode`], quantity: num, kkProductId: spuProduct.kkProductId, price: spuProduct[color][`${size}price`] })
            })
          })
        })
        params.warehouses[0].products = products
        this.loading = true

        API.getLogisticsChannel(params).then(res => {
          if (res.data[0].code === 10000) {
            this.channelError = false
            this.channelList = res.data[0].data
            // 当物流返回时相同类型的渠道返回了多个时，只取同类型渠道中运费最低的渠道在kaka展示
            this.channelList = this.channelList.reduce((current, next) => {
              let index = current.findIndex(e => e.agingGrade === next.agingGrade)
              if (index !== -1) {
                if (current[index].estimatedFreight > next.estimatedFreight) {
                  current.splice(index, 1)
                  current.push(next)
                }
              } else {
                current.push(next)
              }
              return current
            }, [])
            // 表格勾选的时候调接口，目的是计算运费，不必设默认值
            // if (isNoSetDefault) return
            // if (this.channelList.length && this.channelList.length === 1) this.channelActive = this.channelList[0].channelCode
            // if (this.channelList.length && this.channelList.length > 1) this.channelActive = this.channelList[1].channelCode
            // 只有一个则第一个，两个以上默认第二个 (2023/7/20:物流排序值快的在前面，需求：取快的里最便宜的)
            // if (this.channelList.length) this.channelActive = this.channelList[0].channelCode

            // (2023/8/11: express > standard > expedited, 按这个循序取便宜的)
            if (this.channelList.length) {
              if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express') > -1) {
                this.channelActive = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express')].channelCode
              } else if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard') > -1) {
                this.channelActive = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard')].channelCode
              } else if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited') > -1) {
                this.channelActive = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited')].channelCode
              } else {
                this.channelActive = this.channelList[0].channelCode
              }
            }

            if (!this.channelList.length) this.channelActive = undefined
          } else {
            this.channelError = true
            this.channelList = []
          }

          this.parameter.products = [] // 订单商品信息
          params.warehouses.forEach((products) => {
            products.products.forEach((product) => {
              if (Number.parseInt(product.quantity) > 0) {
                this.parameter.products.push({
                  kkProductId: product.kkProductId, // 商品ID
                  skuCode: product.skuCode, // SKU编码
                  skuOriginalPriceAmount: product.price, // SKU原价金额
                  skuQuantity: Number.parseInt(product.quantity) // SKU数量
                })
              }
            })
          })

          if (this.channelList.length >= 2) {
            this.channelList.forEach((item) => {
              // Standard (2023/7/20:物流排序值快的在前面，需求：取快的里最便宜的)
              if (item.agingGrade === 'Express') {
                this.parameter.shippingSubtotal = item.estimatedFreight // 总运费
              }
            })
          } else {
            this.parameter.shippingSubtotal = this.channelList[0].estimatedFreight // 总运费
          }

          this.parameter.selectCouponTicketId = undefined
          // 调用接口获取购物车订单预览信息
          this.getOrderBillingPreviewInfo()
        }).finally(() => {
          this.loading = false
          resolve()
        }).catch(() => {
          this.channelError = true
          this.channelList = []
        })
      })
    },
    isNoMatchingChannelF(row, index) {
      if (!this.addressList.length) return true
      let ReceiptCountry = this.addressList[this.selectAddressIndex] || { countryCode: '' }
      let ReceiptCountryCode = ReceiptCountry.countryCode
      let currentCountryWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { countryCode: '' }
      let warehouseCountryCode = currentCountryWarehouse.countryCode
      if (warehouseCountryCode === 'US' && ReceiptCountryCode !== 'US') return false
      if (warehouseCountryCode === 'DE' && ReceiptCountryCode !== 'DE') return false
      if (warehouseCountryCode === 'GB' && ReceiptCountryCode !== 'GB') return false
      if ([0, 3, 4].includes(row.status)) return false
      if (row.discountType && row.discountType === 1 && row.spikeSoldStock >= row.spikeTotalStock) return false
      return true
    },
    isNoMatchingChannelForHead({ row, column, rowIndex, columnIndex }) {
      if (!this.addressList.length) return true
      if (columnIndex !== 0) return ''
      let ReceiptCountry = this.addressList[this.selectAddressIndex] || { countryCode: '' }
      let ReceiptCountryCode = ReceiptCountry.countryCode
      let currentCountryWarehouse = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive) || { countryCode: '' }
      let warehouseCountryCode = currentCountryWarehouse.countryCode
      if (warehouseCountryCode === 'US' && ReceiptCountryCode !== 'US') return 'disabledAllCheck'
      if (warehouseCountryCode === 'DE' && ReceiptCountryCode !== 'DE') return 'disabledAllCheck'
      if (warehouseCountryCode === 'GB' && ReceiptCountryCode !== 'GB') return 'disabledAllCheck'
      return ''
    },
    couponCodeCheck() {},
    couponApply(value) {
      // 改变了渠道重新获取优惠券
      if (typeof value === 'string') {
        this.channelList.forEach((item) => {
          if (item.channelCode === value) {
            this.parameter.shippingSubtotal = item.estimatedFreight // 总运费
          }
        })

        this.parameter.selectCouponTicketId = undefined
        // 调用接口获取购物车订单预览信息
        this.getOrderBillingPreviewInfo()
      }

      if (!this.couponValue) {
        this.couponInfo = {}
        return
      }
      if (!this.couponCode) {
        this.couponInfo = {}
        return
      }
      // if (!this.$store.state.common.email) {
      //   this.$message.warning('Please enter your vaild email')
      //   return
      // }
      this.couponLoading = true
      let currentCountryItem = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive)
      let currentChannel = this.channelList.find(e => e.channelCode === this.channelActive)
      const selections = currentCountryItem.kkProductIdGroup.filter(e => e.checked)
      const param = {
        couponCode: this.couponCode,
        // userEmail: this.$store.state.common.email,
        hasOtherDiscount: selections.some(e => e.afterDiscountAmount),
        productNum: 0,
        transactionAmount: 0,
        maxProductAmount: 0
      }
      selections.forEach(e => {
        let num = 0
        let numAll = 0
        e.colorAll.forEach(color => {
          e[color].sizeAll.forEach(size => {
            if (e[color][`${size}status`] !== 1) return
            if (e[color].isHaveMinOrderQuantity) {
              num = +e[color][size] * +e[color].packNum
              numAll += +e[color][size] * +e[color].packNum
            } else {
              num = +e[color][size]
              numAll += +e[color][size]
            }
            if (e[color].afterDiscountAmount) param.hasOtherDiscount = true
            if ((e[color].afterDiscountAmount ? e[color].afterDiscountAmount : e.price) > param.maxProductAmount) {
              param.maxProductAmount = (e[color].afterDiscountAmount ? e[color].afterDiscountAmount : e[color].price)
            }
            if (!e[color][size]) return
            if (e[color][`${size}afterDiscountAmount`]) {
              param.transactionAmount += (+e[color][`${size}afterDiscountAmount`] * num)
            } else {
              param.transactionAmount += (+e[color][`${size}price`] * num)
            }
          })
        })
        param.productNum += +numAll
      })
      if (currentChannel) {
        param.transactionAmount += currentChannel.estimatedFreight
      }
      param.transactionAmount = numToFix(param.transactionAmount)
      this.couponInfo = {}
      API.couponCodeCheck(param).then(res => {
        if (res.code !== 10000) {
          this.$set(this.couponInfo, 'message', (!res.message || (res.message && res.message.length) > 200) ? 'system exception' : res.message)
          this.$set(this.couponInfo, 'error', true)
          return
        }
        let data = res.data
        data.message = res.message
        this.$set(this.$data, 'couponInfo', data)
      }).catch((data) => {
        this.$set(this.couponInfo, 'message', (!data.message || (data.message && data.message.length) > 200) ? 'system exception' : data.message)
        this.$set(this.couponInfo, 'error', true)
      }).finally(() => {
        this.couponLoading = false

        this.parameter.selectCouponTicketId = undefined
        // 获取优惠码
        this.parameter.couponCode = this.couponCode
        // 调用接口获取购物车订单预览信息
        this.getOrderBillingPreviewInfo()
      })
    },
    clearCouponCode() {
      if (this.couponCode && this.couponCode.length !== 0) {
        return
      }
      this.couponInfo = {}

      this.parameter.couponCode = undefined
      this.parameter.selectCouponTicketId = undefined
      // 调用接口获取购物车订单预览信息
      this.getOrderBillingPreviewInfo()
    },
    dialogCancel() {
      let warehouseName = this.countryNameActive
      if (['CN_N', 'CN_S'].includes(this.countryNameActive)) {
        warehouseName = 'China'
      }
      this.tableSelectionChangeTime = new Date().valueOf()
      this.$refs[warehouseName][0].clearSelection()
      this.dialogVisible = false
      this.dialogHandleInfo = {
        warehouse: null,
        selections: []
      }
    },
    dialogCheck() {
      this.filterSet.forEach(e => {
        if (e.countryNameForTab !== this.countryNameActive) {
          this.$refs[e.countryNameForTab][0].clearSelection()
          e.selections = []
        }
      })
      this.dialogHandleInfo.warehouse.selections = this.dialogHandleInfo.selections
      this.getLogisticsChannel(true)
      if (this.couponCode) this.couponApply()
      this.dialogVisible = false
      this.dialogHandleInfo = {
        warehouse: null,
        selections: []
      }
    },
    // 确认订单前校验是否维护了邮箱
    checkBindEmail() {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.processCheck()
      }
    },
    setSuccess() {
      this.processCheck()
    },
    processCheck() {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_confirmOrder_click`
      })
      if (!this.addressList.length) {
        this.$message.error('Please enter the address first')
        return
      }
      if (this.$store.state.common.shoppingCarIsNeedTips) {
        this.processVisible = true
      } else {
        window.gtag('event', 'confirm_order')
        window.gtag('event', 'confirm_order', { 'send_to': 'G-4335ZYH2TJ' })
        this.createOrder()
      }
    },
    processDialogSubmit() {
      if (this.isAskMeAgainChecked) {
        const params = {
          type: 3,
          content: JSON.stringify({ text: 'haveChecked' }),
          id: this.$store.state.common.shoppingCarIsNeedTipsUserId
        }
        API.editUserBehaviorConfig(params).then(() => {
          window.gtag('event', 'confirm_order')
          // window.gtag('event', 'confirm_order', { 'send_to': 'G-4335ZYH2TJ' })
          this.createOrder()
        })
      } else {
        window.gtag('event', 'confirm_order')
        // window.gtag('event', 'confirm_order', { 'send_to': 'G-4335ZYH2TJ' })
        this.createOrder()
      }
    },
    /**
   * 创建订单
   */
    createOrder() {
      this.checkoutLoading = true
      let currentCountryItem = this.filterSet.find(e => e.countryNameForTab === this.countryNameActive)
      let currentChannel = this.channelList.find(e => e.channelCode === this.channelActive)
      if (!currentChannel) return this.$message.error('Package overweight or it cannot be delivered to your address. Please connect support team to continue')
      if (!this.currentCountryWarehouse.kkProductIdGroup.filter(e => e.checked).length) return this.$message.error('Please select at least one product')
      const selections = this.currentSelectSku()
      const addr = this.addressList[this.selectAddressIndex]
      const orderAddresses = {
        country: addr.countryCode,
        city: addr.city,
        phone: addr.phoneNumber,
        recipient: addr.fullName,
        street1: addr.streetAddressLine1,
        street2: addr.streetAddressLine2,
        province: addr.province,
        zip: addr.zipCode,
        vat: addr.vatCode,
        ioss: addr.ioss
      }
      const params = {
        orderAddresses,
        itemSubtotal: numToFix(this.tableSubtotalPack),
        shippingSubtotal: currentChannel.estimatedFreight,
        grandTotal: numToFix(this.totalAllPack),
        promotionSubtotal: this.promotionSubtotal,
        paymentMethod: 0,
        cartIds: selections.map(e => e.id),
        channelType: currentChannel.agingGrade // (新加)订单发货速度方式 Standard-标准，Express-快速
      }

      // 优惠码
      if (this.couponInfo.message && !this.couponInfo.error) {
        params.couponCode = this.couponInfo.couponCode
      }
      // 优惠券
      if (this.parameter.selectCouponTicketId) {
        params.selectCouponTicketId = this.parameter.selectCouponTicketId
      }
      const { warehouseCode, countryCode, warehouseType: channelGrouping, warehouseId } = currentCountryItem
      const order = {
        freightAmount: currentChannel.estimatedFreight,
        warehouseCode,
        countryCode,
        channelGrouping,
        warehouseId,
        channelCode: currentChannel.channelCode
      }
      const orderItems = []
      currentCountryItem.kkProductIdGroup.filter(e => e.checked).forEach(e => {
        e.colorAll.forEach(color => {
          e[color].sizeAll.forEach(size => {
            if (e[color][`${size}status`] !== 1) return
            const params = {
              productName: e.skuName,
              kkProductId: e.kkProductId,
              sizeImagePath: e[color][`${size}imgUrl`],
              promotionAmount: e[color][`${size}promotionAmount`],
              afterDiscountAmount: e[color][`${size}afterDiscountAmount`],
              purchasePrices: e[color][`${size}price`],
              discountId: e.discountId,
              productType: e.productType
            }
            let num = 0
            if (e[color].isHaveMinOrderQuantity) {
              num = (e[color][size] * e[color].packNum)
            } else {
              num = e[color][size]
            }
            params.skuCode = e[color][`${size}SkuCode`]
            params.option1 = e[color][`${size}option1String`]
            params.option2 = e[color][`${size}option2String`]
            params.productNum = +num
            params.productNum && orderItems.push(params)
          })
        })
      })
      order.orderItems = orderItems
      params.order = [order]
      API.createOrder(params).then(result => {
        if (result.code === 10000) {
          this.$router.push({
            path: '/mall/paymentPage',
            query: {
              kkOrderId: result.data[0],
              warehouseName: this.countryNameActive,
              weightTotal: numToFix(this.tableWeightTotal)
            }
          })
        } else {
          this.$message.error(result.message)
        }
      }).catch(response => {
        this.$message.error(response.data.message)
      }).finally(() => {
        this.checkoutLoading = false
      })
    },
    itemsNum(item) {
      return item.items.reduce((current, next) => {
        let num = current
        if (next.num) return num + next.num
        return num
      }, 0)
    },
    batchDelete() {
      const currentWarehouse = this.filterSet.find(e => this.countryNameActive === e.countryNameForTab)
      this.$confirm(`<p>
      Delete <span style="color: #99C41C">${currentWarehouse.kkProductIdGroup.filter(e => e.checked).length}</span> items from <span style="color: #99C41C">${currentWarehouse.countryNameForTab}</span> warehouses ?
      </p>`, {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        type: 'error'
      }).then(() => {
        const ids = []
        currentWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(e => {
          e.colorAll.forEach(color => {
            this.cartList.forEach(ee => {
              if (ee.kkProductId === e.kkProductId && ee.option1.value === color) ids.push(ee.id)
            })
          })
        })
        API.deleteCart(ids).then(res => {
          currentWarehouse.kkProductIdGroup = currentWarehouse.kkProductIdGroup.filter(e => !e.checked)
          ids.forEach(id => {
            let index = this.cartList.findIndex(e => e.id === id)
            if (index !== -1) this.cartList.splice(index, 1)
          })
          this.computedNum()
        })
      })
    },
    scrollHeight() {
      return window.document.scrollTop
    },
    computedNum() {
      let productNum = this.cartList.reduce((current, next) => {
        let final = current
        if (next.num) final += next.num
        return final
      }, 0)
      this.$store.commit('common/set', { shoppingCartSkuNum: productNum })
    },
    getEndTimeFormat(discountId) {
      if (this.endTimeObj[discountId] - this.currentTime < 0) return '00:00:00'
      return dayjs(this.endTimeObj[discountId] - this.currentTime).format('HH:mm:ss')
    },
    colorPackQTY(row) {
      let num = 0
      row.sizeAll.forEach(size => {
        if (row[`${size}status`] !== 1) return
        if (row.isHaveMinOrderQuantity) {
          num += +(row[size] * row.packNum)
        } else {
          num += +row[size]
        }
      })
      return num
    },
    colorPackPrice(row) {
      let total = 0
      row.sizeAll.forEach(size => {
        if (row[`${size}status`] !== 1) return
        let price = row.afterDiscountAmount || row.price
        if (row.isHaveMinOrderQuantity) {
          total += (row[size] * row.packNum * price)
        } else {
          total += (row[size] * price)
        }
      })
      return total.toFixed(2)
    },
    selectAll(value, filterSet) {
      filterSet.kkProductIdGroup.forEach(e => {
        if (!e.isDisabled) e.checked = value
      })
      this.getLogisticsChannel().then(() => {
        this.couponApply()
        if (!value) {
          let result = filterSet.kkProductIdGroup.every((product) => product.checked === false)
          if (result) {
            this.parameter.products = []
            this.parameter.shippingSubtotal = undefined
            this.parameter.selectCouponTicketId = undefined
            // 调用接口获取购物车订单预览信息
            this.getOrderBillingPreviewInfo()
          }
        }
      })
    },
    spuCheck(value, filterSet) {
      filterSet.checkAll = filterSet.kkProductIdGroup.every(e => e.checked)
      this.allLoading = this.$loading.service()
      this.getLogisticsChannel().then(() => {
        if (this.couponCode) this.couponApply()
        if (!value) {
          let result = filterSet.kkProductIdGroup.every((product) => product.checked === false)
          if (result) {
            this.parameter.products = []
            this.parameter.shippingSubtotal = undefined
            this.parameter.selectCouponTicketId = undefined
            // 调用接口获取购物车订单预览信息
            this.getOrderBillingPreviewInfo()
          }
        }
      }).finally(() => {
        this.allLoading.close()
      })
      // if (filterSet.kkProductIdGroup.filter(e => e.checked).length) {

      // }
    },
    spuSizeBlur(value, size, row, spuProduct) {
      this.updateCartNumber(row[`${size}SkuCode`], spuProduct.warehouseCode, parseInt(value.target.value || 0))
    },
    colorNumInput(value, row, size) {
      value = value.replace(/[^\d]/g, '')
      row[size] = value
      if (+value > +row[`${size}stock`]) {
        row[size] = row[`${size}stock`]
        this.$message(this.$t('productDetail.maximum') + row[`${size}stock`])
      }
      if (row[size] > 9999) row[size] = 9999
    },
    spuDelete(spuProduct) {
      const ids = []
      spuProduct.colorAll.forEach(color => {
        spuProduct[color].sizeAll.forEach(size => {
          ids.push(spuProduct[color][`${size}Id`])
        })
      })
      API.deleteCart(ids).then(res => {
        const currentWarehouse = this.filterSet.find(e => this.countryNameActive === e.countryNameForTab)
        const index = currentWarehouse.kkProductIdGroup.findIndex(e => e.kkProductId === spuProduct.kkProductId)
        currentWarehouse.kkProductIdGroup.splice(index, 1)
        ids.forEach(id => {
          let index = this.cartList.findIndex(e => e.id === id)
          if (index !== -1) this.cartList.splice(index, 1)
        })
        this.computedNum()
        // 调用物流渠道接口
        this.getLogisticsChannel()
      })
    },
    currentSelectSku() {
      const currentWarehouse = this.filterSet.find(e => this.countryNameActive === e.countryNameForTab)
      const products = []
      currentWarehouse.kkProductIdGroup.filter(e => e.checked).forEach(spuProduct => {
        spuProduct.colorAll.forEach(color => {
          spuProduct[color].sizeAll.forEach(size => {
            if (spuProduct[color][`${size}status`] !== 1) return
            let target = this.cartList.find(e => e.kkProductId === spuProduct.kkProductId && e.option1.value === color && e.option2.value === size)
            products.push(target)
          })
        })
      })
      return products
    },
    productBatch(value, row, spuProduct) {
      const cartParams = []
      row.sizeAll.forEach(size => {
        if (row[`${size}status`] !== 1) return
        cartParams.push({
          warehouseCode: spuProduct.warehouseCode,
          skuCode: row[`${size}SkuCode`],
          kkProductId: spuProduct.kkProductId,
          num: row[size] * row.packNum
        })
      })
      API.addBatchCart({ cartParams })
      this.getLogisticsChannel().then(() => {
        this.couponApply()
        this.computedNum()
      })
    },
    processDialogClose() {
      this.processVisible = false
      this.isAskMeAgainChecked = false
    },

    // 购物车起订量限制最大数量
    maxPackNum(row) {
      let maxPackNum = 0
      row.sizeAll.forEach(size => {
        if (!maxPackNum) maxPackNum = Math.floor(row[`${size}stock`] / row[size])
        if (maxPackNum > Math.floor(row[`${size}stock`] / row[size])) maxPackNum = Math.floor(row[`${size}stock`] / row[size])
      })
      return maxPackNum
    },
    jumpHref(path) {
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
// 优惠券模块
.car-coupon {
  padding: 16px 26px;
  margin-bottom: 10px;
  background-color: #fff;
  .el-collapse {
    border-top: none;
    /deep/.el-collapse-item__header {
      height: 100%;
      line-height: 100%;
      border-bottom: none;
      .car-coupon-tips {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .car-title {
          color: #10141D;
          font-size: 18px;
          font-weight: 500;
        }
        .car-available {
          display: flex;
          margin-right: 5px;
          align-items: center;
          justify-content: center;
          .icon-youhuiquan {
            color: #E3444E;
            font-size: 20px;
            margin-right: 5px;
          }
          span {
            color: #10141D;
          }
        }
        .car-tips {
          color: #CDD4DD;
          font-size: 14px;
        }
      }
      .el-collapse-item__arrow {
        margin: 0 !important;
      }
    }
    /deep/.el-collapse-item__wrap {
      border-bottom: none;
      .el-collapse-item__content {
        margin-top: 16px;
        padding-bottom: 0;
        line-height: normal;
      }
    }
    .car-coupons-ul {
      display: grid;
      max-height: 320px;
      grid-gap: 12px 12px;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 100%);
      overflow: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .car-coupon-item {
        width: 100% !important;
      }
    }
    .not-data {
      display: flex;
      width: 340px;
      height: 100%;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      img {
        width: 58%;
      }
      .tips-text {
        color: #747a87;
        font-size: 14px;
        margin-top: 18px;
      }
    }
  }
  .choose-to-use {
    display: flex;
    width: 317px;
    height: 32px;
    margin: 16px auto 0;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #e3444e;
    background: rgba(227, 68, 78, 0.03);
    .icon-youhuiquan {
      color: #E3444E;
      font-size: 20px;
    }
    .get-info {
      margin-left: 5px;
      .get {
        color: #10141D;
      }
      .discount {
        color: #E3444E;
      }
    }
  }
}

.contain{
  max-width: 1400px;
  margin: 0 auto;
  min-width: 1000px;
  padding: 0 15px 40px;
  .topBack {
      margin: 20px 0 10px;
  }
  .content{
      .content_left{
          flex: 1;
          margin-right:36px;
          .left_shippingAddress {
              .text_tip{
                  font-weight: bold;
                  font-size: 16px;
              }
              .select-another-address {
                font-size: 14px;
                color: #99c41c;
              }
          }
          .warehouse{
              .title {
                  margin-bottom: 10px;
              }
              .deleteIcon {
                color: #747A87;
                font-size: 14px;
              }
              .multiple_tip{
                  line-height: 30px;
                  font-size: 16px;
              }
              .warehouseTabs {
                  /deep/.el-tabs__nav-wrap {
                      display: flex;
                  }
                  /deep/.el-tabs__nav-wrap::before{
                      content: 'Warehouses：';
                      font-weight: bold;
                      font-size: 16px;
                      line-height: 40px;
                      margin-right: 16px;
                  }
                  /deep/.el-tabs__item{
                      font-weight: bold !important;
                  }
                  .numInput{
                    /deep/.el-input__inner{
                      text-align: center;
                      border-radius: 6px !important;
                    }
                  }
                  .noMatchingTip {
                    background-color: rgba(229, 51, 83, 0.06);
                    padding: 4px 16px;
                    font-size: 12px;
                    color: #E3444E;
                    margin-bottom: 6px;
                    line-height: 18px;
                  }
                  .inDiscount {
                    >p:nth-of-type(1) {
                      font-size: 16px;
                      line-height: 24px;
                      color: #10141D;
                    }
                    >p:nth-of-type(2) {
                      font-size: 12px;
                      color: #747A87;
                      text-decoration: line-through;
                    }
                  }
                  .product_group{
                    margin-bottom: 30px;
                    .product_img {
                      margin-right: 8px;
                      .img {
                        width: 114px;
                        height: 152px;
                        position: relative;
                        /deep/ .el-image {
                          border-radius: 6px;
                          width: 100%;
                          height: 100%;
                        }
                        .tag-pod {
                          position: absolute;
                          bottom: 8px;
                          background-color: #F7FCEB;
                          width: 100%;
                          height: 18px;
                          font-size: 14px;
                          line-height: 18px;
                          text-align:center;
                          color: #9AC331;
                        }
                      }
                    }
                    .productInfo{
                      .productTitle{
                        font-size: 14px;
                        margin-bottom: 8px;
                      }
                      .productPrice{
                        margin-bottom: 8px;
                        >span:nth-of-type(1) {
                          font-size: 16px;
                          margin-right: 8px
                        }
                        >span:nth-of-type(2) {
                          font-size: 12px;
                          color: #747A87;
                          text-decoration: line-through;
                        }
                      }
                      .colorGroup{
                        margin-bottom: 16px;
                        .colorText{
                          font-size: 14px;
                        }
                        /deep/.is-leaf{
                          background-color: rgba(0, 0, 0, 0.02) !important;
                        }
                      }
                    }
                  }
                  .select_all{
                    margin-bottom: 30px
                  }
              }
          }
          .deliveryMethod{
            .channel_group{
              .channel_item{
                padding: 12px 16px;
                width: 490px;
                border: 1px solid #CDD4DD;
                margin-bottom: 10px;
              }
              .channel_item_active{
                border-color: #99C41C;
              }
            }
          }
      }
      .content_right{
          min-width: 392px;
          .orderAmount{
            .subtotal_item{
              margin-bottom: 14px;
              >p:nth-of-type(1) {
                color: #747A87;
                font-size: 14px;
              }
              >p:nth-of-type(2) {
                font-size: 16px;
              }
            }
            .subtotal_all {
              margin-bottom: 14px;
              >p:nth-of-type(1) {
                font-size: 18px;
              }
              >p:nth-of-type(2) {
                font-size: 24px;
              }
            }
            .checkoutBtn {
              margin-bottom: 14px;
              >button{
                width: 100%;
              }
            }
            .numTip{
              text-align: center;
              font-size: 14px;
              span{
                color: #99C41C;
              }
            }
            .paymentOptions {
              p{
                text-align: center;
                color: #8B93A3;
                font-size: 14px;
                margin-bottom: 8px;
              }
              .icon_group {
                img{
                  height: 14px;
                }
              }
            }
            .haveCut {
              color: #E3444E;
            }
          }
          .coupon {
            .couponInput{
              margin-bottom: 14px;
              /deep/.el-input__inner{
                border-top-left-radius: 4px !important;
                border-bottom-left-radius: 4px !important;
                height: 44px;
                line-height: 44px;
              }
              /deep/.el-input-group__append{
                background-color: #99C41C;
                color: #FFFFFF;
                cursor: pointer;
              }
            }
            .couponCheckTip {
              .canUse{
                margin-bottom: 14px;
                >i{
                  color: #99C41C;
                  font-size: 20px;
                  margin-right: 4px;
                }
                span{
                  font-size: 12px;
                }
              }
              .promoNum {
                width: 290px;
                margin: 0 auto;
                background-color: rgba(227, 68, 78, 0.03);
                border: 1px solid #E3444E;
                border-radius: 4px;
                font-size: 14px;
                line-height: 22px;
                padding: 4px 0;
                .price {
                  color: #E3444E;
                  margin-left: 2px;
                }
              }
            }
            .coupon-code {
              margin: 10px 0;
              height: 36px;
              border-radius: 30px;
              border: 1px solid #CDD4DD;
              position: relative;
              .coupon-code-input{
                width: 76%;
                /deep/.el-input__inner {
                  height: 34px;
                  border: unset;
                }
              }
              .coupon-code-btn{
                height: 100%;
                border-radius: 30px;
                position: absolute;
                right: 0;
                line-height: 14px;
              }
            }
            .coupon-bar {
              width: 290px;
              height: 32px;
              border: 0.5px solid #E3444E;
              background: rgba(227, 68, 78, 0.03);
              border-radius: 4px;
              margin: 0 auto;
              margin-top: 10px;
            }
            .icon-a-close-line1 {
              border-radius: 50%;
              border: .5px solid #E3444E;
              font-size:16px;
              margin-right:6px;
            }
            .success {
              color: #99C41C;
            }
            .error {
              color: #E3444E;
            }
          }
          /deep/.checkoutBtn{
            button[disabled] {
              background-color: #CDD4DD;
              border-color: #CDD4DD;
            }
          }
      }
  }
  .content_item{
      background-color: #FFFFFF;
      padding: 16px 26px;
      border-radius: 3px;
      margin-bottom: 10px;
  }
}
.current-address {
font-size: 14px;
color: #8b93a3;
}
.add-new-address {
font-size: 14px;
color: #99c41c;
line-height: 30px;
padding-bottom: 14px;
}
.address-item {
width: 377px;
border: 0.5px solid #cdd4dd;
border-radius: 6px;
padding: 15px 15px 26px 15px;
margin-bottom: 17px;
overflow: hidden;
span {
  position: absolute;
  right: 10px;
  bottom: 4px;
  color: #99c41c;
}
}
.address-item-activated {
border: 0.5px solid #99c41c;
.activated-icon {
  display: block;
  position: absolute;
  right: -35px;
  top: -35px;
  width: 60px;
  height: 60px;
  border-radius: 100px;
  background: #99c41c;
  color: white;
  i {
    position: absolute;
    bottom: 3px;
    left: 8px;
  }
}
}
.activated-icon {
display: none;
}
.zeroMB {
margin-bottom: 14px !important;
}
.common-problem{
padding: 15px 25px;
h3 {
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #000000;
  padding-bottom: 25px;
}
p {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: underline;
  padding-bottom: 15px;
}
}
.dialogCheckTip {
.dialogCheckTip_icon{
  margin-right: 12px;
  font-size: 28px;
}
.dialogCheckTip_font{
  font-size: 12px;
  line-height: 20px;
}
}
.rightIsFixed {
position: fixed;
top: 120px;
}
.isShow {
display: block !important;
}
.soldOut{
  position: absolute;
  top: 60px;
  left: 0;
  height: 20px;
  color: #828282;
  background-color: #D9D9D9;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 60px;
  text-align: center;
}
.soldOut{
  position: absolute;
  top: 60px;
  left: 0;
  height: 20px;
  width: 60px;
  background-color: #D9D9D9;
  color: #828282;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  text-align: center;
}
.tableSoldOut{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #828282;
}
.colorBookTable{
      /deep/.el-input__inner{
        border-radius: 0;
        height: 32px;
        line-height: 32px;
        padding: 0;
        text-align: center;
      }
      /deep/.el-input-number__decrease{
        height: 30px;
        line-height: 32px;
        width: 22px;
        background-color: #ffffff;
        top: 2px;
      }
      /deep/.el-input-number__increase{
        width: 22px;
        height: 30px;
        line-height: 32px;
        background-color: #ffffff;
        top: 2px;
      }
      .packInput{
        /deep/.el-input__inner{
          border-radius: 4px !important;
        }
      }
    }

</style>

<style lang="scss">
.disabledAllCheck {
color: #99C41C ;
  .el-checkbox{
    display: none !important;
  }
}
.processCheckingDialog{
  .el-dialog__body{
    padding: 10px 50px 20px 36px !important;
    .iconBox{
      width: 28px;
      font-size: 28px;
      color: #E53353;
      margin-right: 10px;
    }
    .noteBox{
      .note1{
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 18px;
      }
    }
  }
}
</style>
